import React, { useContext } from 'react';
import { Container } from 'reactstrap';
import Header from '../../component/Header';
import NoDataState from '../../component/NoDataState';
import { AppContext } from '../../context/app-context';
import BookCard from './BookCard';

const MyBooking = () => {

  const [state, dispatch] = useContext(AppContext);
  return(
    <>
      <Header title="My Bookings" isBookingNavDisplay={false} />
      <Container>
        {state?.consultationList?.length > 0 ? <BookCard booking={state.consultationList} /> : 
          <NoDataState />
        }
      </Container>
    </>
  );
}

export default MyBooking;